import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'usb-promotions',
  template:   `
             <ng-container *ngIf="promotionsApplied?.promotion?.currency">
                       <div class="d-flex flex-column"  style="border:2px solid #ed3b5b;background-color:white; border-radius: 50rem;width: 80%; padding-top: 7px; padding-bottom: 7px; padding-left: 13px;">
                        <p class="mb-0" style="font-family: 'Poppins', serif;font-size: 10px;font-weight: 500; line-height: 1;color: #ed3b5b;">Ahorras</p>
                        <p class="mb-0" style="font-family: 'Poppins', serif;font-size: 10px;font-weight: 600; line-height: 1;color: #ed3b5b;">
                           {{promotionsApplied?.promotion?.currency ? currencyAgency?.code :''}}
                          {{promotionsApplied?.promotion?.discount_value  | currencyConverterPure:
                           promotionsApplied?.itemCurrency:
                            currencyAgency?.code:
                              currencies
                            | number: '1.2-2'}}
                          </p>
                      </div>
                  </ng-container>
                  <ng-container *ngIf="!promotionsApplied?.promotion?.currency">
                      <div class="d-flex justify-content-center align-items-center"  style="border:2px solid #ed3b5b;background-color:white; border-radius: 50rem;width: 75%;margin-bottom: 3px;height: 26px">
                        <p class="mb-0" style="font-family: 'Poppins', serif;font-size: 14px;font-weight: 600;color: #ed3b5b;">{{promotionsApplied?.promotion?.discount_value}}% OFF</p>
                      </div>
                  </ng-container>

  `,
  styleUrls: ['../base-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PromotionsComponent implements OnInit {

  @Input() promotionsApplied: any;
  @Input() currencies: any;
  @Input() currencyAgency: any;

  constructor() { }

  ngOnInit(): void {
  }

}
